import { useRuntimeConfig } from "#app/nuxt";

export function setSeoMeta(
    title: string,
    description: string,
    image: string | null = null,
    type: string | null = 'website',
) {
    if (image === null) {
        image = useRuntimeConfig().public.appUrl + '/og-image.jpg'
    }

    if (type === null) {
        type = 'website'
    }

    useSeoMeta({
        title: title,
        ogTitle: title,
        description: description,
        ogDescription: description,
        ogImage: image,
        ogType: type == 'article' ? 'article' : 'website',
        twitterCard: 'summary_large_image',
        twitterImage: image,
        twitterSite: useRuntimeConfig().public.twitterHandle,
        ogSiteName: useRuntimeConfig().public.appName,
    })
}
